import { EntityDataTypes } from "@comparaonline/offers-models";
import { Schema as ProductsSchema } from "@comparaonline/products-schema";
import { Schema as QuoterSchema } from "@comparaonline/quoter-schema";
import { isInsuranceByKm } from "./isInsuranceByKm";
import { INSURANCE_BY_KM_ATTRIBUTE_VARIABLE } from "./constants";

type MainAttribute = ProductsSchema.ProductListProductAttribute | null | undefined;

const isOffer = (product: any) => Boolean(product.mainAttribute);

const findMainAttribute = (attributes: ProductsSchema.ProductListProduct["productAttributes"]) =>
  attributes!.find(attribute => Boolean(attribute) && Boolean(attribute!.featured));

const getProductMainAttribute = (product: ProductsSchema.ProductListProduct): MainAttribute => {
  const attributes = product.featuredAttributes || product.productAttributes;
  return Array.isArray(attributes) ? findMainAttribute(attributes) : undefined;
};

const getOfferMainAttribute = (product: QuoterSchema.Product): MainAttribute => {
  if (!isInsuranceByKm(product)) {
    return product.mainAttribute;
  }

  const {
    mainAttribute: { entity, value },
    productAttributes
  } = product;

  const {
    value: { amount: variableAmount }
  } = productAttributes.find(pa => pa.entity.code === INSURANCE_BY_KM_ATTRIBUTE_VARIABLE);

  return {
    ...product.mainAttribute,
    entity: {
      ...entity,
      dataType: EntityDataTypes.doublePrice,
      secondLabel: "Precio KM"
    },
    value: {
      ...value,
      second: variableAmount
    }
  };
};

export const getMainAttribute = (
  product: ProductsSchema.ProductListProduct | QuoterSchema.Product
): MainAttribute =>
  isOffer(product) ? getOfferMainAttribute(product) : getProductMainAttribute(product);
